var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-button",
    {
      staticClass: "is-button-secondary is-fullwidth-mobile",
      attrs: {
        label: _vm.$t("create-broker"),
        type: "is-primary",
        "icon-left": "fa-solid fa-user-plus",
        rounded: "",
      },
      on: { click: _vm.cardModal },
    },
    [_vm._v(" /> ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }